<script lang="ts" module>
  export type AlertBannerProps = {
    banners: Banner[];
  }
</script>

<script lang="ts">
  import type { Banner } from '../../../types/navData';

  import { css } from '@agapi/ui/panda/css';
  import { icon } from '@agapi/ui/panda/patterns';
  import { Button } from '@agapi/ui/button';
  import { alertBannerStyles } from './navbar-alert-banner.styles';
  import { XCircle } from 'phosphor-svelte';
  import { dynamicColorStyles } from '@agapi/ui/panda/utils';
  import { getCookie, setCookie } from '../../../utils';
  import * as m from '$lib/parachute/messages';

  const { banners }: AlertBannerProps = $props();
  const currentBanners = $state(banners);

  const classes = alertBannerStyles.raw();
</script>

<ul class={css(classes.root)}>
  {#each currentBanners as banner, index}
  {@const { color, backgroundColor } = dynamicColorStyles(banner.color_variant)}
  {@const hasLink = banner.link?.url}
  {@const linkTarget = banner.link?.target === '_self' ? '_self' : banner.link?.target ?? '_self'}
  {@const buttonText = banner.link?.link_text}

  <li class={css(classes.item)} style={`--banner-color: ${color}; --banner-bg: ${backgroundColor}; color: var(--banner-color); background: var(--banner-bg);`}>
    {#if hasLink}
      <a
        href={banner.link!.url}
        target={linkTarget}
        rel={linkTarget === '_blank' ? 'noopener noreferrer' : undefined}
        class={css(classes.clickable)}
      >
        <div class={css(classes.label)}>
          <span>{banner.label}</span>
          {#if buttonText}
          <Button
            variant="text"
            size="sm"
            as="span"
              css={{
                color: 'var(--banner-color)',
                textDecoration: 'underline',
              }}
          >
            {buttonText}
          </Button>
          {/if}
        </div>
      </a>
    {:else}
      <span class={css(classes.label)}>{banner.label}</span>
    {/if}

    {#if banner.is_closable}
      <XCircle
        class={icon({ size: 'sm', cursor: 'pointer' })}
        onclick={(e) => {
          e.stopPropagation();
          const removedBanner = currentBanners.splice(index, 1);
          if (removedBanner.length && removedBanner[0].id) {
            const [{ id }] = removedBanner;
            const removedBanners = getCookie('agapi-navbar-alert-banners');
            setCookie('agapi-navbar-alert-banners', removedBanners ? `${removedBanners},${id}` : `${id}`);
          }
        }}
      >
        <title>{m.iconClose()}</title>
      </XCircle>
    {/if}
  </li>
  {/each}
</ul>
